import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter, Route } from "react-router-dom"
import mixpanel from "mixpanel-browser"
;(async () => {
  console.log({ Mode: process.env.NODE_ENV !== "production" })
  mixpanel.init(process.env.REACT_APP_MIXPANEL, {
    debug: process.env.NODE_ENV !== "production",
  })
  ReactDOM.render(
    <React.StrictMode>
      <BrowserRouter>
        <Route component={App} />
      </BrowserRouter>
    </React.StrictMode>,
    document.getElementById("root")
  )
})()

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
